export default __webpack_public_path__ + "static/media/shape5.15aa8153.svg";